export default "__VITE_ASSET__sv3ampjr__"